import { render } from "./HeadingOverviewQualification.vue?vue&type=template&id=4c506740&scoped=true"
import script from "./HeadingOverviewQualification.vue?vue&type=script&lang=js"
export * from "./HeadingOverviewQualification.vue?vue&type=script&lang=js"

import "./HeadingOverviewQualification.vue?vue&type=style&index=0&id=4c506740&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c506740"]])

export default __exports__